import { Badge } from 'components/shadcn/ui/badge';
import { CheckIcon, ExclamationTriangleIcon, ArrowPathIcon } from '@heroicons/react/24/outline';
import AcknowledgedCheckbox from './AcknowledgedCheckbox';
import { addSpaceBeforeEveryCapitalLetter } from 'components/HGForm/helpers';
import DateTimeCell from './DateTimeCell';

export const statusIcons = {
    Complete: (
        <CheckIcon className="w-4 h-4 text-success mr-1" />
    ),
    DownloadComplete: (
        <CheckIcon className="w-4 h-4 text-success mr-1" />
    ),
    Failed: (
        <ExclamationTriangleIcon className="w-4 h-4 text-error mr-1" />
    ),
    other: (
        <ArrowPathIcon className="w-4 h-4 text-info mr-1" />
    ),
};

export const upgradeHistoryColumns = [
    {
        Header: 'Upgrade ID',
        accessor: 'UpdateID',
        component: (item) => (
            <>
                {item.state !== 'Failed' &&
                item.state !== 'Complete' &&
                item.state !== 'Acknowledge' ? (
                    <Badge
                        color="success"
                        className="pl-0 font-bold text-muted-foreground"
                    >
                        {item.UpdateID}
                    </Badge>
                ) : (
                    <span className="text-muted-foreground">
                        {item.UpdateID}
                    </span>
                )}
            </>
        ),
    },
    {
        Header: 'Status',
        accessor: 'state',
        component: (item) => (
            <span className="text-muted-foreground flex items-center min-w-[80px]">
                {item.state === 'Complete' || item.state === 'Failed'
                    ? statusIcons[item.state]
                    : statusIcons['other']}
                {addSpaceBeforeEveryCapitalLetter(item.state)}
            </span>
        ),
    },
    {
        Header: 'Acknowledged',
        accessor: 'acknowledged',
        component: (item) => <AcknowledgedCheckbox item={item} />,
    },
    {
        Header: 'Last Updated',
        accessor: 'lastUpdatedTime',
        component: (item) => <DateTimeCell item={item} />,
    },
];
